import React, { FC, ReactNode, useState } from "react";

import { Divider, Stack, Typography, Chip, Dropdown } from "@components/base";

const Menu: FC = () => {
  const [optionSelected, setOptionSelected] = useState<string | ReactNode | null>(
    null,
  );
  const [chipOptionSelected, setChipOptionSelected] = useState<ReactNode | null>(
    null,
  );

  const options: Dropdown["options"] = Array.from({ length: 3 }).map((_, index) => ({
    id: `options-${index}`,
    title: `Option ${index + 1}`,
  }));

  const chipOptions: Dropdown["options"] = Array.from({ length: 3 }).map(
    (_, index) => ({
      id: `options-${index}`,
      title: <Chip label={`Chip ${index + 1}`} color="blue1" />,
    }),
  );

  return (
    <Stack spacing={4}>
      <Typography variant="h2">Menu</Typography>
      <Divider />
      <Stack spacing={4}>
        <Stack spacing={2}>
          <Typography variant="subtitle1">Default</Typography>
          <Dropdown
            button={{
              title: optionSelected ? optionSelected : "Dropdown",
              variant: "outlined",
              size: "small",
            }}
            options={options}
            onSelect={(option) => setOptionSelected(option.title)}
          />
        </Stack>
        <Stack spacing={2}>
          <Typography variant="subtitle1">Default with Chip</Typography>
          <Dropdown
            button={{
              title: chipOptionSelected ? chipOptionSelected : "Dropdown",
              variant: "text",
              size: "small",
            }}
            options={chipOptions}
            onSelect={(option) => setChipOptionSelected(option.title as ReactNode)}
          />
        </Stack>
        <Stack spacing={2}>
          <Typography variant="subtitle1">Default with Chip no endIcon</Typography>
          <Dropdown
            button={{
              title: chipOptionSelected ? chipOptionSelected : "Dropdown",
              variant: "text",
              size: "small",
              hideEndIcon: true,
            }}
            options={chipOptions}
            onSelect={(option) => setChipOptionSelected(option.title)}
          />
        </Stack>
      </Stack>
    </Stack>
  );
};

export default Menu;
